import { InjectionToken } from '@angular/core';
import { CoreMeta } from '@iris/modules/module-filters-v2/filter-meta';
import { Observable } from 'rxjs';

export const MODULE_FILTER_META = new InjectionToken<CoreMeta[] | Observable<CoreMeta[]>>('Module filter meta');
